<template>
  <div
    class="school_QWE"
    :class="[ getTerminalForChrome() ? 'school_QWE-mo': 'school_QWE-pc', showTabs ? 'center' : '']"
  >
<!--    <div
      class="head box"
      :class="[ getTerminalForChrome() ? 'head-mo': 'head-pc', showTabs ? 'col-g' : '']"
    >-->
    <div
      class="head"
      :class="[ getTerminalForChrome() ? 'head-mo': 'head-pc', showTabs ? 'col-g' : '']"
    >
      <Head :menuList="getMenuList()" @change="handleChange"></Head>
    </div>
    <div class="nav-tabs" v-if="showTabs && !getTerminalForChrome()">
      <div class="tabs-list">
        {{nav.first}}
        <span v-if="nav.second">>></span>
        <span @click="toUrl(nav.second)" style="cursor: pointer">{{nav.second}}</span>
        <span v-if="nav.third">>></span>
        <span>{{nav.third}}</span>
      </div>
    </div>
    <div
      class="main"
      :class="[ getTerminalForChrome() ? 'main-mo': 'main-pc', showTabs ? 'w14' : '', showOne ? 'w100' : '']"
    >
      <router-view />
    </div>
    <div class="foot" :class="[ getTerminalForChrome() ? 'foot-mo': 'foot-pc']">
      <span class="text copy-layout">
        版权所有：广报高山学校 <span class="pl5">备案号：</span>
        <a href="http://beian.miit.gov.cn/" target="_blank">粤ICP备05145335号-1</a>
      </span>
      <span class="text">办学许可证：教民4401047000120号 粤民证字第010315号</span>
    </div>
    <div class="info-bar">
      <div class="image follow">
        <!--<img id="BizQQWPA" src="../../assets/consultation.jpg" alt="">-->
        <img src="../../assets/consultation.jpg" alt="" @click="showQrcode">
        <div class="sub-img2" id="img5" v-if="qrcodeStatus">
          <img src="../../assets/qrcode2.jpg" id="img6" alt="">
        </div>
        <!-- <div></div> -->
      </div>
      <div class="image follow" id="img1">
        <img src="../../assets/follow.jpg" id="img2" alt="" @click="showFollow">
        <div class="sub-img" id="img3" v-if="followStatus">
          <img src="../../assets/qrcode.jpg" id="img4" alt="">
        </div>
      </div>
<!--      <div class="image follow" id="img2_1">
        <img src="../../assets/follow2.png" id="img2_2" alt="" @click="showFollow2">
        <div class="sub-img" id="img2_3" v-if="follow2Status">
          <img src="../../assets/qrcode3.png" id="img2_4" alt="">
        </div>
      </div>-->
    </div>
    <!-- <div
      class="customer"
      id="cus1"
      :class="[ getTerminalForChrome() ? 'customer-mo': 'customer-pc']"
    >
      <div class="contact-box" id="cus2" v-show="showCus">
        <div class="qq-box" id="cus3">
          <div class="image" id="cus4">
            <img
              src="'http://wpa.b.qq.com/cgi/wpa.php?key=XzgwMDAyOTkzM18zMDgwNTJfODAwMDI5OTMzXw'"
              alt
            />
          </div>
          <div class="text" id="cus5">
            <a
              href="tencent://message/?Menu=yes&amp;uin=800029933&amp;Site=广州高山文化培训学校&amp;Service=10&amp;sigT=10&amp;sigU=10"
            >QQ交谈</a>
          </div>
        </div>
        <div class="code-box" id="cus6">
          <img src="../../assets/qrcode.jpg" id="cus7" alt />
        </div>
        <div class="cur"></div>
      </div>
      <div class="cus-icon" @click="handleShowCus" id="cus8">
        <img src="../../assets/customer.png" id="cus9" alt />
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex';
import { post } from '../../api/index';
import Head from './components/Head';
import { getCategory } from '@/api/school';
export default {
  components: {
    Head
  },
  data() {
    return {
      showCus: false,
      isMobile: false,
      showTabs: false,
      followStatus: true,
      follow2Status: false,
      qrcodeStatus: false,
      showOne: false,
      nav: {
        first: '',
        second: '',
        secondUrl: '',
        third: ''
      },
      menuList: [
        {
          title: '首页',
          actived: true,
          url: '/',
          show: false
        },
        {
          title: '学校概况',
          actived: false,
          children: [],
          show: false,
          url: '/chapter'
        },
        {
          title: '招生简章',
          actived: false,
          children: [],
          show: false
        },
        {
          title: '高山资讯',
          actived: false,
          children: [],
          show: false
        },
        {
          title: '党团之窗',
          actived: false,
          children: [],
          show: false
        },
        {
          title: '联系我们',
          actived: false,
          url: '/contact',
          show: false
        }
      ]
    };
  },
  created() {
    if (
      navigator.userAgent.match(
        /(phone | pad | pod | iPhone | iPod | ios | iPad | Android | Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|WindowsPhone)/i
      )
    ) {
      this.IS_MOBILE(true);
    } else {
      this.IS_MOBILE(false);
    }
  },
  mounted() {
    this.globalClick(this.closeFollow);
    setTimeout(() => {
      this.getMenu();
    }, 200);
    // setTimeout(() => {
    // const text = document.querySelector('.qq-box .text');
    // let script = document.createElement('script');
    // script.type = 'text/javascript';
    // script.src =
    //   'http://wpa.b.qq.com/cgi/wpa.php?key=XzgwMDAyOTkzM18zMDgwNTJfODAwMDI5OTMzXw';
    // console.log('text', text)
    // text.appendChild(script);
    // setTimeout(() => {
    //   const iframes = document.querySelectorAll('iframe');
    //   console.log('iframes', iframes)
    //   for (let i = 0; i < iframes.length; i++) {
    //     console.log('iframes[i]0', iframes[i]);
    //     if (iframes[i].clientWidth) {
    //       const iframe = iframes[i];
    //       if (this.getTerminalForChrome()) {
    //         iframe.style.position = 'fixed';
    //         iframe.style.top = '65vh';
    //         iframe.style.right = '18vw';
    //         iframe.style.zIndex = '99';
    //         iframe.style.width = '26.66vw';
    //         iframe.style.boxShadow = '0px 2px 4px 0px black';

    //         this.showCus = true;
    //       } else {
    //         iframe.style.position = 'fixed';
    //         iframe.style.top = '600px';
    //         iframe.style.right = '116px';
    //         iframe.style.zIndex = '99';
    //         iframe.style.boxShadow = '0px 2px 4px 0px black';

    //         this.showCus = true;
    //       }
    //     }
    //   }
    //   // console.log('ifam', document.querySelectorAll('iframe'), iframe);
    // }, 1500);
    // }, 500);
  },
  watch: {
    '$route.path': function(val) {
      console.log('paht', val)
      const urls = [
        {path: '/chapter', name: '学校概况'},
        {path: '/recruit', name: '招生简章'},
        {path: '/information', name: '高山资讯'},
        {path: '/membership', name: '党员之窗'},
        {path: '/detail', name: '正文'}
      ];
      if (val === '/') {
        this.showTabs = false;
        this.showOne = false
      } else if(val === '/chapter') {
        this.showTabs = true;
        this.showOne = true
      } else {
        this.showTabs = true;
        this.showOne = false
      }
      let nav = JSON.parse(sessionStorage.getItem('nav'))
      if (val.indexOf('/detail') > -1) {
        nav.third = '正文'
      } else {
        nav.third = ''
      }
      this.nav = nav
      sessionStorage.setItem('nav', JSON.stringify(this.nav))
      // this.nav = JSON.parse(sessionStorage.getItem('nav'))
    }
  },
  methods: {
    ...mapMutations(['IS_MOBILE', 'MENU_LIST']),
    ...mapGetters(['getTerminalForChrome', 'getMenuList']),
    toQq() {
      let a = document.createElement('a')
      // a.href = 'tencent://message/?Menu=yes&amp;uin=800029933&amp;Site=广州高山文化培训学校&amp;Service=10&amp;sigT=10&amp;sigU=10'
      // a.href = 'http://wpa.qq.com/msgrd?v=3&uin=800029933&site=广州高山文化培训学校&menu=yes'
      // a.href = this.getTerminalForChrome() ? "mqqapi://card/show_pslcard?src_type=internal&version=1&uin=800029933&card_type=person&source=qrcode" : "tencent://message/?Menu=yes&amp;uin=800029933&amp;Site=广州高山文化培训学校&amp;Service=10&amp;sigT=10&amp;sigU=10"
      a.href = 'mqqwpa://im/chat?chat_type=wpa&uin=800029933&version=1&src_type=web&web_src=bjhuli.com'
      if (!this.getTerminalForChrome()) a.href = 'tencent://message/?Menu=yes&amp;uin=800029933&amp;Site=广州高山文化培训学校&amp;Service=10&amp;sigT=10&amp;sigU=10'
      // a.href = "mqqapi://card/show_pslcard?src_type=internal&version=1&uin=800029933&card_type=person&source=qrcode"
      // console.log('aaa',this.getTerminalForChrome(), a.href)
      a.click()
      // a = null
    },
    showQrcode(){
      this.qrcodeStatus = !this.qrcodeStatus;
      this.followStatus = false;
      this.follow2Status = false
    },
    closeFollow() {
      this.followStatus = false
      //this.qrcodeStatus = false
    },
    showFollow() {
      // todo
      this.followStatus = !this.followStatus
      this.qrcodeStatus = false;
      this.follow2Status = false
    },
    showFollow2() {
      // todo
      this.follow2Status = !this.follow2Status
      this.qrcodeStatus = false;
      this.followStatus = false
    },
    toDo() {
      setTimeout(() => {
        const iframes = document.querySelectorAll('iframe');
        for (let i = 0; i < iframes.length; i++) {
          if (iframes[i].clientWidth) {
            const iframe = iframes[i];
            iframe.style.top = '-10000px';
          }
        }
        this.showCus = false;
      }, 200);
    },
    handleShowCus() {
      if (!this.showCus) {
        if (!document.querySelector('iframe')) {
          setTimeout(() => {
            console.log('yuansu', document.querySelector('.qq-box .text'));
            const text = document.querySelector('.qq-box .text');
            let script = document.createElement('script');
            script.type = 'text/javascript';
            script.src =
              'http://wpa.b.qq.com/cgi/wpa.php?key=XzgwMDAyOTkzM18zMDgwNTJfODAwMDI5OTMzXw';
            text.appendChild(script);
            setTimeout(() => {
              const iframes = document.querySelectorAll('iframe');
              console.log('iframes', iframes);
              for (let i = 0; i < iframes.length; i++) {
                console.log('iframes[i]0', iframes[i]);
                if (iframes[i].clientWidth) {
                  const iframe = iframes[i];
                  if (this.getTerminalForChrome()) {
                    iframe.style.position = 'fixed';
                    iframe.style.top = '65vh';
                    iframe.style.right = '18vw';
                    iframe.style.zIndex = '99';
                    iframe.style.width = '26.66vw';
                    iframe.style.boxShadow = '0px 2px 4px 0px black';
                  } else {
                    iframe.style.position = 'fixed';
                    iframe.style.top = '600px';
                    iframe.style.right = '228px';
                    iframe.style.zIndex = '99';
                    iframe.style.boxShadow = '0px 2px 4px 0px black';
                  }
                }
              }
              // console.log('ifam', document.querySelectorAll('iframe'), iframe);
              this.showCus = !this.showCus;
            }, 400);
          }, 300);
        } else {
          const iframes = document.querySelectorAll('iframe');
          for (let i = 0; i < iframes.length; i++) {
            console.log('iframes[i]0', iframes[i]);
            if (iframes[i].clientWidth) {
              const iframe = iframes[i];
              if (this.getTerminalForChrome()) {
                iframe.style.top = '65vh';
              } else {
                iframe.style.top = '600px';
              }
            }
          }

          this.showCus = !this.showCus;
        }
      } else {
        setTimeout(() => {
          const iframes = document.querySelectorAll('iframe');
          for (let i = 0; i < iframes.length; i++) {
            console.log('iframes[i]0', iframes[i]);
            if (iframes[i].clientWidth) {
              const iframe = iframes[i];
              iframe.style.top = '-10000px';
            }
          }
          this.showCus = !this.showCus;
        }, 200);
      }
    },
    toUrl(title) {
      let url = ''
      const menu = this.menuList
      menu.forEach(v => {
        if (v.children && v.children.length) {
          v.children.forEach(m => {
            if (m.title === title) {
              url = m.url
            }
          })
        }
      })
      this.$router.push({
        path: url
      });
      const nav = JSON.parse(sessionStorage.getItem('nav'))
      nav.third = ''
      this.nav = nav
      sessionStorage.setItem('nav', JSON.stringify(nav))
    },
    getMenu() {
      getCategory({}).then(res => {
        if (res.status === 200) {
          const { data } = res.data;
          const menu = this.menuList;
          const urls = ['/chapter', '/recruit', '/information', '/membership'];
          data.forEach(v => {
            menu[Number(v.categorybelong)].children.push({
              title: v.catname,
              actived: false,
              url: `${urls[Number(v.categorybelong) - 1]}?id=${v.rec_id}`,
              content: v.content || '',
              description: v.description,
              categorybelong: v.categorybelong,
              rec_id: v.rec_id,
              categorytype: v.categorytype,
              color: v.color,
              thumbUrl: v.thumbUrl
            });
          });
          let obj = {
            first: '',
            second: '',
            secondUrl: '',
            third: ''
          }
          let tem = JSON.parse(sessionStorage.getItem('nav')) || {}
          const val = this.$route.fullPath
          const flag = val.indexOf('/detail') > -1
          menu.forEach(v => {
            if (v.url === val) {
              v.actived = true
              tem = {
                first: v.title,
                second: '',
                secondUrl: '',
                third: ''
              }
            } else {
              v.actived = false
            }
            if (v.children && v.children.length) {
              v.children.forEach(m => {
                if (m.url === val) {
                  m.actived = true
                  v.actived = true
                  tem = {
                    first: v.title,
                    second: m.title,
                    secondUrl: '',
                    third: ''
                  }
                } else {
                  m.actived = false
                }
              })
            }
          })
          console.log('tem', tem)
          this.nav = tem
          sessionStorage.setItem('nav', JSON.stringify(this.nav))
          this.MENU_LIST(menu);
        }
      });
    },
    handleChange(v, m) {
      console.log(v.url,'vvvv')
      let obj = {
        first: '',
        second: '',
        secondUrl: '',
        third: ''
      };
      if(v.url) {
        this.$router.push({
          path: v.url
        });
        obj.first = v.title
      } else if (m.url) {
        this.$router.push({
          path: m.url
        });
        obj.first = v.title
        obj.second = m.title
      }
      // if (!m) {
      //   this.$router.push({
      //     path: v.url
      //   });
      //   obj.first = v.title
      // } else {
      //   this.$router.push({
      //     path: m.url
      //   });
      //   obj.first = v.title
      //   obj.second = m.title
      // }
      const menu = this.menuList
      menu.forEach(v => {
        if (v.title === obj.first) {
          v.actived = true
        } else {
          v.actived = false
        }
        if (v.children && v.children.length) {
          v.children.forEach(m => {
            if (m.title === obj.second) {
              m.actived = true
              v.actived = true
            } else {
              m.actived = false
            }
          })
        }
      })
      this.MENU_LIST(menu)
      this.nav = obj
      sessionStorage.setItem('nav', JSON.stringify(this.nav));
    }
  }
};
</script>

<style lang="scss" scoped>

.box {
  text-align: center;
  /* @Key 透明度 R G B Alpha（不透明度为50%） */
  background-color: rgba(64, 224, 208, 0.5);
  /* @Key 圆角矩形 */
  -moz-border-radius: 0em;
  -webkit-border-radius: 0em;
  border-radius: 0em;
  /* @Key 投影 投影偏移3px，宽6px，颜色#666 */
  -webkit-box-shadow: 1px 1px 1px #666;
  -moz-box-shadow: 1px 1px 1px #666;
  box-shadow: 0.1px 0.1px 6px #999;
}

.school_QWE {
  position: relative;
  .head {
    width: 100%;
    //background: #FFFFFF;
  }
  .head {
    //position: fixed;
    position: absolute;
    z-index: 10;
  }
  .main-pc {
    min-height: calc(100vh - 88px - 124px - 57px);
    //margin-top: 130px;
  }
  .foot-pc {
    width: 100%;
    height: 88px;
    display: flex;
    align-items: center;
    justify-content: center;
    // background-image: linear-gradient(180deg, #47b97e 0%, #327adf 100%);
    background: url('../../assets/foot.jpeg') no-repeat center center;
    background-size: 100% 100%;
    .text {
      font-size: 16px;
      color: #ffffff;
      letter-spacing: 0;
      &:first-child {
        margin-right: 64px;
      }
    }
  }
  .customer-pc {
    position: fixed;
    right: 10px;
    top: 567px;
    z-index: 10;
    .contact-box {
      left: -160px;
      top: 14px;
      position: absolute;
      width: 155px;
      // height: 174px;
      background: #ffffff;
      border: 2px solid #ffffff;
      box-shadow: 0 0 20px 0 rgba(185, 185, 185, 0.52);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 16px;
      // position: relative;
      .qq-box {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 106px;
        height: 24px;
        // background: #31a087;
        border-radius: 3px;
        .image {
          width: 16px;
          height: 20px;
          margin-right: 8px;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .text {
          font-size: 14px;
          color: #ffffff;
          a {
            color: #fff;
            text-decoration: none;
          }
        }
      }
      .code-box {
        width: 106px;
        // height: 106px;
        // background-color: red;
        margin-top: 10px;
        img {
          width: 100%;
          // height: 100%;
          // object-fit: contain;
        }
      }
      .cur {
        width: 0;
        height: 0;
        border: 10px solid;
        border-color: transparent transparent transparent #fff;
        position: absolute;
        right: -22px;
        top: 14px;
      }
    }
    .cus-icon {
      width: 70px;
      height: 60px;
      // position: absolute;
      // right: -70px;
      // top: -18px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
  .info-bar {
    position: fixed;
    z-index: 10;
    right: 0;
    top: 20%;
    .image {
      cursor: pointer;
      box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.7);
      &:not(:last-child) {
        margin-bottom: 10px;
      }
    }
  }
}
.school_QWE-pc {
  min-width: 1280px;
  display: flex;
  flex-direction: column;
  // align-items: center;
  &.center {
    align-items: center;
  }
  .col-g {
    // background-image: linear-gradient(180deg, #47b97e 0%, #327adf 80%);
    background: url('../../assets/head.jpeg') no-repeat center center;
    background-size: 100% 100%;
    position: relative;
  }
  .nav-tabs {
    width: 100%;
    display: flex;
    justify-content: center;
    .tabs-list {
      // min-width: 1280px;
      width: 75%;
      padding: 16px 0px;
      border-bottom: 1px solid #d2d2d2;
      font-size: 16px;
      color: #333333;
    }
  }
  .w14 {
    // width: 1440px;
    // width: 1280px;
    // padding: 0px 320px;
    // min-width: 1280px;
    // padding: 0px 320px;
    width: 75%;
    margin: 0 auto;
  }
  .w100 {
    width: 100% !important;
    margin: 0 auto;
  }
  .foot {
    .copy-layout {
      a {
        color: #fff;
      }
      .pl5 {
        // padding-left: 5px;
        // text-indent: 2em;
        padding-left: 24px;
      }
    }
  }
  .info-bar {
    .image {
      width: 70px;
      height: 80px;
      img {
        width: 100%;
      }
    }
    .follow {
      position: relative;
      .sub-img {
        position: absolute;
        width: 150px;
        top: 0px;
        right: 80px;
        box-shadow: 0px 2px 4px #888;
        background: #fff;
        img {
          width: 100%;
        }
      }

      .sub-img2 {
        position: absolute;
        width: 150px;
        top: 0px;
        right: 80px;
        box-shadow: 0px 2px 4px #888;
        background: #fff;
        img {
          width: 100%;
        }
      }
    }
  }
}
.school_QWE-mo {
  position: relative;
  .col-g {
    // background-image: linear-gradient(180deg, #47b97e 0%, #327adf 80%);
    background: url('../../assets/head.jpeg') no-repeat center center;
    background-size: cover;
    position: relative;
  }
  .w14 {
    min-height: calc(100vh - 25.07vw - 13.07vw);
  }
  .foot {
    width: 100vw;
    height: 13.07vw;
    background: url('../../assets/foot.jpeg') no-repeat center center;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .text {
      font-size: 2.67vw;
      color: #fff;
    }
  }
  .customer {
    position: fixed;
    right: 2.67vw;
    top: 65vh;
    .contact-box {
      // display: none;
      position: absolute;
      width: 32vw;
      padding: 2.67vw;
      background-color: #fff;
      top: 0px;
      right: 100%;
      .qq-box {
        display: flex;
        align-items: center;
        justify-content: center;
        // background: #31a087;
        border-radius: 0.4vw;
        .image {
          width: 3.73vw;
          height: 3vw;
          display: flex;
          align-items: center;
          margin-right: 2.13vw;
          img {
            width: 100%;
          }
        }
        .text {
          a {
            color: #fff;
            font-size: 1.87vw;
          }
        }
      }
      .code-box {
        width: 100%;
        img {
          width: 100%;
        }
      }
    }
    .cus-icon {
      width: 14.13vw;
      height: 14.13vw;
      background-color: #fff;
      border: 0.13vw solid #44afa3;
      border-radius: 50%;
      box-shadow: 0 0 16px 0 #61afb1;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 11.47vw;
      }
    }
  }
  .info-bar {
    .image {
      width: 9.33vw;
      height: 10.67vw;
      img {
        width: 100%;
      }
    }
    .follow {
      position: relative;
      .sub-img {
        position: absolute;
        width: 22vw;
        top: 0px;
        right: 10.66vw;
        box-shadow: 0px 2px 4px #888;
        img {
          vertical-align: middle;
          width: 100%;
        }
      }
    }
  }
}
iframe {
  // position: fixed;
  top: 600px;
  right: 228px;
  z-index: 99;
}
</style>
